var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "100%",
    height: "100%",
    viewBox: "0 0 485 485",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.04395,0,0,9.04395,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.627,49.385L37.795,33.553C40.423,30.046 42,25.709 42,21C42,9.42 32.58,0 21,0C9.42,0 0,9.42 0,21C0,32.58 9.42,42 21,42C25.709,42 30.046,40.423 33.553,37.795L49.385,53.627L53.627,49.385ZM2,21C2,10.523 10.523,2 21,2C31.477,2 40,10.523 40,21C40,31.477 31.477,40 21,40C10.523,40 2,31.477 2,21Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17853,0,0,1.17853,-221.049,-197.943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.564,268.552L332.564,268.552L332.564,315.168L285.948,315.168L285.948,345.168L332.564,345.168L332.564,391.783L362.564,391.783L362.564,345.168L409.18,345.168L409.18,315.168L362.564,315.168L362.564,268.552Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.36c453a6cef6875237073b7267f32314.svg";
export { ForwardRef as ReactComponent };